import axios from 'axios'

type Props = {
  id: number
  redirectPath: string
}

export const delContactGroup = async (props: Props) => {
  const { id } = props

  return await axios.delete(
    `${process.env.REACT_APP_API_URL}/contactGroup/${id}`,
    {
      withCredentials: true,
    },
  )
}
